"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _formik = require("formik");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var Yup = _interopRequireWildcard(require("yup"));
var _Button = _interopRequireDefault(require("../../../../components/Button"));
var _Input = _interopRequireDefault(require("../../../../components/Input"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DeletionConfirm = function DeletionConfirm(_ref) {
  var email = _ref.email,
    onClose = _ref.onClose,
    onDelete = _ref.onDelete,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 bg-card"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-3xl font-bold "
  }, t('settings.customDomain.subAccountDetail.deletionConfirm.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm text-gray-light"
  }, t('settings.customDomain.subAccountDetail.deletionConfirm.description')), /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValue: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().oneOf([email]).required()
    }),
    render: function render(_ref2) {
      var dirty = _ref2.dirty,
        errors = _ref2.errors;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        name: "email",
        spellCheck: "false",
        autoComplete: "off",
        className: "w-full my-8 font-semibold",
        placeholder: t('settings.customDomain.subAccountDetail.deletionConfirm.placeholder')
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "secondary",
        onClick: onClose,
        className: "mr-2 w-32"
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "warning",
        disabled: disabled || !(0, _isEmpty["default"])(errors) || !dirty,
        onClick: onDelete,
        className: "w-48 flex-shrink-0"
      }, t('settings.customDomain.subAccountDetail.dangerZone.button'))));
    }
  }));
};
var _default = exports["default"] = DeletionConfirm;
//# sourceMappingURL=DeletionConfirm.js.map